// import { FETCH_WORDCLOUD_DATA } from "./wordCloudAction";

const moment = require("moment-timezone");

export const getDownloadParams = (ext, data, sortOption, influencers, sentiment, sentimentType, media, channel, postType, sampling, exclusion) => {
    let params = new URLSearchParams();

    // duration
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.duration === "custom") {
        //params.append('start_date', moment(data.start_date).tz(tz).format('YYYY-MM-DDTHH:mm:ss'))
        params.append("start_date", moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss"));
        //params.append('end_date', moment(data.end_date).tz(tz).format('YYYY-MM-DDTHH:mm:ss'))
        params.append("end_date", moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss"));
    } else if (data.duration === "24HRS") {
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:59"));
        // params.append('end_date', moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'))
        params.append("start_date", moment(new Date()).tz(tz).subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss"));
        // params.append('start_date', moment(new Date()).subtract(1,'days').format('YYYY-MM-DDTHH:mm:ss'))
    } else {
        params.append("duration", data.duration);
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.delete("end_date");
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss"));
    }
    if (data.parent_id) {
        params.append("parent_id", data.parent_id);
    }

    params.append("download_name", "unified/conversations");
    data.platforms && params.append("platform", data.platforms);
    data.countries && params.append("location", data.countries);
    data.languages && params.append("language", data.languages);

    params.append("data", 1);

    // entity type
    if (data.entityType !== "all" && data.entityType !== "") {
        formatEntityType(params, data.entityType, data.entitySubType);
    }

    !data.emptyTopics && params.append("topic_data", JSON.stringify(data.topics_data));

    // sort option
    if (sortOption === "published_date_desc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
    } else if (sortOption === "published_date_asc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "asc");
    } else if (sortOption === "impact_prediction_score") {
        params.append("orderBy", "impact_prediction_score");
    } else if (sortOption === "trending_now_virality") {
        params.append("virality_parameter", 0);
        params.append("orderBy", "impact_value");
    } else if (sortOption === "predicted_virality") {
        params.append("virality_parameter", 1);
        params.append("orderBy", "impact_prediction_score");
    } else params.append("orderBy", sortOption);

    params.append("download_type", ext);
    params.append("recordsPerPage", 50);

    // refine filter
    if (sentiment !== "ALL") {
        params.append("sentiment", sentiment);
        data.extras = data.extras.filter((e) => e.key !== "Sentiment");
    }
    if (sentimentType !== "ALL") params.append("sentiment_source", sentimentType);

    if (contentSafety !== "sfw") {
        params.append("contentSafety", contentSafety);
    }

    if (contentSafetyType !== "all") params.append("content_safety_source", contentSafetyType);

    if (media !== "ALL") {
        params.append("post_media_type", media);
        data.extras = data.extras.filter((e) => e.key !== "post_media_type");
    }
    if (channel && channel !== "ALL") {
        params.append("source_type", channel);
        data.extras = data.extras.filter((e) => e.key !== "Source Type");
    }
    if (postType !== "ALL") params.append("post_type", postType);

    if (data.custom_query && data.custom_query !== "") {
        params.append("custom_query", data.custom_query);
    }
    if (data.post_address_country) {
        params.append("post_address_country", data.post_address_country);
    }
    if (sampling && sampling != 100) {
        if (!(data.extras && data.extras[0] && data.extras[0].key == "Impact")) params.set("orderBy", "rand");
        params.set("sampling_value", sampling);
    }

    const influencer_type_filter = JSON.parse(localStorage.getItem("influencer_type_filter"));
    if (influencer_type_filter && influencers && influencers.length) {
        if (influencers[0] !== "all") params.set("influencer_types", influencers.join(","));
        // else params.set("influencer_types", "Owned,Athlete,Paid Media,Competitor,Paid KOL,Celeb,paid,Earned")
    }

    if (data.selected_fields) {
        params.set("selected_fields", data.selected_fields);
    }

    if (exclusion) {
        params.set("apply_exclusion", exclusion);
    }

    if (data.publications) {
        if (data.publications === "all_tagged_pubs")
            params.append(
                "publication",
                JSON.parse(localStorage.getItem("filterOptions"))
                    .publications.map((elem) => elem.name)
                    .toString(),
            );
        else if (data.publications === "all_untagged_pubs") params.append("fields_not_exist", "publications");
        else if (data.publications === "not_listed_pubs") {
            let configured_publications = JSON.parse(localStorage.getItem("filterOptions")).publications.map((elem) => elem.name);
            params.append("publications_not_in", configured_publications.toString());
        } else params.append("publication", data.publications);
    }

    addExtraParams(data, params);

    return params;
};

export const getRawDataUrlParams = (
    data,
    offset,
    sortOption,
    influencers,
    sentiment,
    sentimentType,
    media,
    channel,
    postType,
    exclusion,
    sampling,
    searchDataType = 0,
    allDataCharts,
) => {
    let params = new URLSearchParams();
    if (typeof searchDataType !== "undefined") {
        // condition to check if searchDataType is passed from the function call location.
        data.languages && (searchDataType != "1" || (searchDataType == "1" && allDataCharts)) && params.append("language", data.languages);
        data.countries && (searchDataType != "1" || (searchDataType == "1" && allDataCharts)) && params.append("location", data.countries);
        data.platforms && (searchDataType != "1" || (searchDataType == "1" && allDataCharts)) && params.append("platform", data.platforms);
    }

    // duration
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.graph && data.graph === "GAUGE") {
        params.append("start_date", moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("end_date", moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss"));
    } else if (data.duration === "custom") {
        /* params.append('start_date', moment(data.start_date).tz(tz).format('YYYY-MM-DDTHH:mm:ss'))
    params.append('end_date', moment(data.end_date).tz(tz).format('YYYY-MM-DDTHH:mm:ss')) */
        params.append("start_date", moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("end_date", moment(data.end_date).format("YYYY-MM-DDTHH:mm:59"));
    } else if (data.duration === "24HRS") {
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:59"));
        params.append("start_date", moment(new Date()).tz(tz).subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss"));
    } else {
        params.append("duration", data.duration);
    }
    if (data.post_address_country && (searchDataType != "1" || (searchDataType == "1" && allDataCharts))) {
        params.append("post_address_country", data.post_address_country);
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.delete("end_date");
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:59"));
    }

    params.append("data", 1);

    // entity type
    if (data.entityType !== "all" && data.entityType && data.entityType !== "" && (searchDataType != "1" || (searchDataType == "1" && allDataCharts))) {
        formatEntityType(params, data.entityType, data.entitySubType);
    }

    if (data.publications && (searchDataType != "1" || (searchDataType == "1" && allDataCharts))) {
        if (data.publications === "all_tagged_pubs")
            params.append(
                "publication",
                JSON.parse(localStorage.getItem("filterOptions"))
                    .publications.map((elem) => elem.name)
                    .toString(),
            );
        else if (data.publications === "all_untagged_pubs") params.append("fields_not_exist", "publications");
        else if (data.publications === "not_listed_pubs") {
            let configured_publications = JSON.parse(localStorage.getItem("filterOptions")).publications.map((elem) => elem.name);
            params.append("publications_not_in", configured_publications.toString());
        } else params.append("publication", data.publications);
    }

    // let keyword = []
    // let boolean = []

    // data.topics_data.forEach(topic => {
    //   keyword.push(topic.topic_id)
    //   boolean = boolean.concat(topic.subtopicIds)
    // })
    // params.append('keyword', keyword)
    // params.append('boolean', boolean)

    if (data.topicAccount === "account" && (searchDataType != "1" || (searchDataType == "1" && allDataCharts))) params.append("social_accounts", "all");
    else if (!data.emptyTopics && (searchDataType != "1" || (searchDataType == "1" && allDataCharts)))
        params.append("topic_data", JSON.stringify(data.topics_data));

    //change sort option for engagement charts
    // let newFilter = JSON.parse(localStorage.getItem('newFilter'))
    // if(newFilter.filter_data.extras && newFilter.filter_data.extras.length>0){
    //   newFilter.filter_data.extras.forEach(e=>{
    //     if(e.key==="Impact") {
    //       sortOption = 'impact_value'
    //       postType = 0
    //     }
    //   })
    // }

    // sort option

    if (sortOption === "published_date_desc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
    } else if (sortOption === "published_date_asc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "asc");
    } else if (sortOption === "impact_prediction_score") {
        params.append("orderBy", "impact_prediction_score");
    } else if (sortOption === "trending_now_virality") {
        params.append("virality_parameter", 0);
        params.append("orderBy", "impact_value");
    } else if (sortOption === "predicted_virality") {
        params.append("virality_parameter", 1);
        params.append("orderBy", "impact_prediction_score");
    } else if (sortOption === "impact_value") {
        params.append("post_type", 0);
        params.append("orderBy", "impact_value");
    } else params.append("orderBy", sortOption);

    params.append("offset", offset);
    params.append("recordsPerPage", 50);

    // refine filter
    if (sentiment !== "ALL") {
        params.append("sentiment", sentiment);
        data.extras = data.extras.filter((e) => e.key !== "Sentiment");
    }
    if (sentimentType !== "ALL") params.append("sentiment_source", sentimentType);

    if (contentSafety !== "sfw") {
        params.append("contentSafety", contentSafety);
    }

    if (contentSafetyType !== "ALL") params.append("content_safety_source", contentSafetyType);

    if (media !== "ALL") {
        params.append("post_media_type", media);
        data.extras = data.extras.filter((e) => e.key !== "post_media_type");
    }

    if (channel !== "ALL") {
        params.append("source_type", channel);
        data.extras = data.extras.filter((e) => e.key !== "Source Type");
    }
    if (postType !== "ALL") params.append("post_type", postType);

    if (data.custom_query && data.custom_query !== "") {
        params.append("custom_query", data.custom_query);
    }
    if (data.tag_category_ids) {
        params.append("tag_category_ids", data.tag_category_ids);
    }

    (searchDataType != "1" || (searchDataType == "1" && allDataCharts)) && params.append("apply_exclusion", exclusion);

    if (sampling && sampling != 100) {
        if (!(data.extras && data.extras[0] && data.extras[0].key == "Impact")) params.set("orderBy", "rand");
        params.set("sampling_value", sampling);
    }

    const influencer_type_filter = JSON.parse(localStorage.getItem("influencer_type_filter"));
    if (influencer_type_filter && influencers && influencers.length) {
        if (typeof influencers === "string") {
            influencers = influencers.split(",");
        }
        if (influencers[0] !== "all") params.set("influencer_types", influencers.join(","));
        else {
            // const influencersList = JSON.parse(localStorage.getItem("influencersList"))
            // params.set("influencer_types", influencersList.map(i => i.name).join(","));
        }
    }

    if (parseInt(sessionStorage.getItem("searchDataType"), 0) === 1) {
        params.set("public_data", 1);
    }

    addExtraParams(data, params);
    return params;
};

const addExtraParams = (data, params) => {
    if (data.extras) {
        data.extras.forEach((param) => {
            if (param.key === "Gender") {
                let genderVal = param.value === "unknown" ? "unknown,na,unisex" : param.value;
                params.append("gender", genderVal);
            }
            if (param.key === "region") params.append("region", param.value);
            if (param.key === "Source Type") params.append("source_type", param.value === "online" ? "0,1,3" : "2");
            if (param.key === "Sentiment") params.append("sentiment", param.value);
            if (param.key === "orderBy") {
                params.set("orderBy", param.value);
                params.set("order", "desc");
            }
            if (param.key === "clustering_category") params.append("clustering_category", param.value);
            if (param.key === "clustering_keyword") params.append("clustering_keyword", param.value);
            if (param.key === "User") params.append("username", param.value);
            if (param.key === "post_media_type") params.append("post_media_type", param.value);
            if (param.key === "Drilled Down Words") {
                let contentTerms = param.value[param.value.length - 1];
                params.append("content_terms", contentTerms);
                let drilldownQuery = param.value.slice(0, param.value.length - 1);
                if (drilldownQuery.length > 0) params.append("wordcloud_drilldown_query", drilldownQuery.map((w) => `+"${w}"`).join(" "));
            }
            if (param.key === "OCR Drilled Down Words") {
                let contentTerms = param.value[param.value.length - 1];
                params.ocr_content_terms = contentTerms;
                let drilldownQuery = param.value.slice(0, param.value.length - 1);
                if (drilldownQuery.length > 0) params.ocr_wordcloud_drilldown_query = drilldownQuery.map((w) => `+"${w}"`).join(" ");
            }
        });
    }
};

export const formatEntityType = (params, et, est) => {
    let paramest = [];
    let entityType = et.split(",");
    let entitySubType = est.split(",");

    let boolStrings = [];

    if (entityType.includes("person")) {
        let personBoolean = "post.entity_type:person ";
        let subParams = [];
        if (entitySubType.includes("male")) subParams.push("male");
        if (entitySubType.includes("female")) subParams.push("female");
        if (entitySubType.includes("unknown")) subParams.push("unknown");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            personBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${personBoolean})`);
    }

    if (entityType.includes("non-person")) {
        let nonPerBoolean = "post.entity_type:non-person ";
        let subParams = [];
        if (entitySubType.includes("brand")) subParams.push("brand");
        if (entitySubType.includes("news")) subParams.push("news");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            nonPerBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${nonPerBoolean})`);
    }

    if (entityType.includes("unknown")) {
        boolStrings.push(`(post.entity_type:unknown)`);
    }

    params.append("entity_boolean", boolStrings.join(" OR "));
};
